import { BRAND } from "@/lib/brand";

/**
 * 심볼 , H 의 두 기둥과 가로대. 수소(H₂)의 H 이자 공정 흐름의 '연결' 을 뜻한다.
 * 획 하나짜리 monoline 이라 16px 탭 아이콘에서도 살아남는다. public/icon.svg 와 같은 그림이다.
 */
export function H2Glyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={2.6} strokeLinecap="round" aria-hidden>
      <path d="M6 5v14M18 5v14M6 12h12" />
    </svg>
  );
}

/** 심볼 하나 , 파란 정사각 판에 흰 글리프 */
export function BrandMark({ className = "" }: { className?: string }) {
  return (
    <span aria-hidden className={`grid size-brand shrink-0 place-items-center rounded-control bg-accent text-on-accent ${className}`}>
      <H2Glyph className="size-icon" />
    </span>
  );
}

/** 로고 잠금 , 심볼 + 이름. 이름 문자열은 brand.ts 에서만 쓴다 */
export function Wordmark({ as: Tag = "span", className = "" }: { as?: "h1" | "span"; className?: string }) {
  return (
    <span className={`flex shrink-0 items-center gap-item ${className}`}>
      <BrandMark />
      <Tag className="shrink-0 text-subhead font-extrabold tracking-tight text-ink">{BRAND.NAME}</Tag>
    </span>
  );
}
